<template>
  <nav v-if="!disablePagination" class="flex justify-between items-center px-2">
    <Flex center gap-3 class="text-gray-500">
      <div>
        Exibindo
        <b>{{ modelValue * max - max + 1 }}</b> à
        <b>{{ modelValue * max < totalItems ? modelValue * max : totalItems }}</b> de <b>{{ totalItems }}</b> itens.
      </div>
      <div>
        <Select class="w-[200px]" :items="items" v-model="modelLimit" up />
      </div>
    </Flex>

    <Flex center v-if="totalPages > 1" class="rounded-lg border divide-x">
      <!-- <NavButton class="border" icon="fa-solid fa-chevron-left" @click="previousPage" />
      <NavButton class="border">
        {{ modelValue }}
      </NavButton>
      <NavButton class="border" icon="fa-solid fa-chevron-right" @click="nextPage" /> -->

      <div :class="{ [disableClass]: currentPage == 1 }" @click="previousPage">
        <NavButton class="border-e-0 rounded-s-lg" icon="fa-solid fa-chevron-left mx-2" />
      </div>

      <Flex center v-if="totalPages < 5" class="divide-x">
        <div v-for="i in totalPages" :key="i" @click="goToPage(i)">
          <NavButton :class="[`${currentPage === i ? activeClass : borderClass}`]">
            {{ i }}
          </NavButton>
        </div>
      </Flex>

      <Flex center v-else class="divide-x">
        <div @click="goToPage(1)">
          <NavButton :class="[`${currentPage == 1 ? activeClass : borderClass}`]">1</NavButton>
        </div>

        <div v-if="currentPage != 1 && currentPage != 2">
          <NavButton> ... </NavButton>
        </div>

        <div v-if="currentPage != 1 && currentPage != totalPages" :class="activeClass">
          <NavButton> {{ currentPage }} </NavButton>
        </div>

        <div v-if="currentPage != totalPages && currentPage != totalPages - 1">
          <NavButton> ... </NavButton>
        </div>

        <div @click="goToPage(totalPages)">
          <NavButton :class="[`${currentPage == totalPages ? activeClass : borderClass}`]">
            {{ totalPages }}
          </NavButton>
        </div>
      </Flex>

      <div :class="{ [disableClass]: currentPage == totalPages }" @click="nextPage">
        <NavButton class="border-s-0 rounded-e-lg" icon="fa-solid fa-chevron-right mx-2" />
      </div>
    </Flex>
  </nav>
</template>

<script setup>
import { ref, onMounted, watch, computed } from 'vue'

const emit = defineEmits(['update:modelValue', 'update:max'])
const props = defineProps({
  totalItems: Number,
  modelValue: {
    type: Number,
    default: 1,
  },
  max: {
    type: Number,
    default: 1,
  },
})

const activeClass = ref('bg-blue-500 hover:bg-blue-600 text-white ')
const borderClass = ref('hover:bg-gray-100')
const disableClass = ref('opacity-50')

const currentPage = ref(1)
const modelLimit = ref(props.max)

const items = ref([
  { value: 10, label: '10' },
  { value: 20, label: '20' },
  { value: 50, label: '50' },
  { value: 100, label: '100' },
])

const goToPage = (pageNumber) => {
  let page = parseInt(pageNumber)
  currentPage.value = page
}

const nextPage = () => {
  if (currentPage.value < totalPages.value) {
    currentPage.value++
  }
}

const previousPage = () => {
  if (currentPage.value > 1) {
    currentPage.value--
  }
}

const totalPages = computed(() => {
  return Math.ceil(props.totalItems / modelLimit.value)
})

watch(
  () => props.modelValue,
  (newVal) => {
    currentPage.value = newVal
  }
)

watch(currentPage, (page) => {
  emit('update:modelValue', page)
})

watch(modelLimit, (newValue) => {
  currentPage.value = 1
  emit('update:max', parseInt(newValue))
})

watch(
  () => props.actualPage,
  () => {
    currentPage.value = 1
  }
)

onMounted(() => {
  currentPage.value = props.modelValue
})
</script>
